var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBronzeRank1(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "bronze_rank_1_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 23,
    width: 178,
    height: 154
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.386 23H11v154h177.386V23z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bronze_rank_1_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.344 27.198c-4.253-5.8-12.928-5.538-16.875.478-10.301 15.714-10.366 36.857 1.385 52.892 14.665 20.011 42.322 24.7 62.638 10.973L46.344 27.198z",
    fill: "#D8966B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.216 61.067c-6.62-2.747-13.91 2-14.183 9.2-.716 18.809 10.119 36.923 28.431 44.522 22.852 9.476 48.923-.922 59.23-23.248L61.147 75.964 25.223 61.067h-.007z",
    fill: "#D38959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.342 27.198c4.253-5.8 12.928-5.538 16.875.478 10.301 15.714 10.366 36.857-1.385 52.892-14.664 20.011-42.322 24.7-62.638 10.973l47.148-64.343z",
    fill: "#D8966B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.17 61.067c6.626-2.747 13.91 2 14.183 9.2.715 18.809-10.119 36.923-28.432 44.522-22.852 9.476-48.923-.922-59.23-23.248l37.549-15.577 35.923-14.897h.007z",
    fill: "#D38959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.423 29.814h100.083c5.983 0 10.841 4.886 10.841 10.902v75.061c0 33.79-27.28 61.223-60.882 61.223s-60.882-27.433-60.882-61.223V40.716c0-6.017 4.858-10.902 10.84-10.902z",
    fill: "#CE7C46"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M66.595 55.305h69.74c4.168 0 7.55 3.4 7.55 7.593v45.947c0 23.542-19.009 42.664-42.427 42.664-23.41 0-42.426-19.116-42.426-42.664v-45.94c0-4.193 3.382-7.593 7.55-7.593l.013-.007z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.341 57.921c2.731 0 4.949 2.237 4.949 4.977v45.947c0 22.084-17.864 40.048-39.819 40.048-21.954 0-39.825-17.964-39.825-40.048v-45.94c0-2.747 2.224-4.977 4.95-4.977h69.739m0-2.616h-69.74c-4.168 0-7.55 3.4-7.55 7.592v45.947c0 23.562 18.996 42.664 42.426 42.664 23.431 0 42.42-19.102 42.42-42.664V62.904c0-4.191-3.381-7.592-7.55-7.592h-.006z",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.767 29.814L40.589 62.18v48.026l79.937-80.39h-47.76zM96.666 96.936l63.015-63.368c-1.99-2.295-4.91-3.753-8.175-3.753h-15.158L83.133 83.328l13.533 13.608z",
    fill: "#fff",
    opacity: 0.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeRank1);
export default ForwardRef;